import { render } from "./AllItems.vue?vue&type=template&id=44a1b8bc&scoped=true"
import script from "./AllItems.vue?vue&type=script&lang=js"
export * from "./AllItems.vue?vue&type=script&lang=js"

import "./AllItems.vue?vue&type=style&index=0&id=44a1b8bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a1b8bc"]])

export default __exports__